<div class="row items-center" [ngClass]="columnRevers ? 'md:flex-row-reverse' : ''">
    @for (item of imageCardData; track $index) {
    <div class="col-md-6">
        <div class="intro-text !mb-0" [ngClass]="columnRevers ? 'xl:pl-[70px]' : 'xl:pr-[70px]'">
            <h2 class="heading-primary-8xl !mb-6" [innerHTML]="item.title"></h2>
            <img [ngSrc]="assetsCDNUrl+item.image_url" alt="golbal-image" width="555" height="437"
                class="w-full mb-4 md:mb-9 md:hidden" loading="eager" fetchpriority="high">
            <div class="editor-content " [innerHTML]="item.sub_title"></div>
            @if(!columnRevers){
            <a type="button" routerLink="/about-us" title="Know More"
                class="button button-orange  button-rounded button-arrow mt-4 md:mt-8">Know More</a>
            }
        </div>
    </div>
    <div class="col-md-6">
        <img [ngSrc]="assetsCDNUrl+item.image_url" alt="golbal-image" width="555" height="437"
            class="w-full hidden md:block" loading="eager">
    </div>
    }
</div>